import { getRequiredEnvValue } from '../env';

export function getFontFullPath(fontName: string): string {
  return `${getRequiredEnvValue('CLOUDFRONT_STATIC_ASSET_URL')}content-lab/fonts/${fontName}`;
}
